
import React from 'react'
import { NavLink } from 'react-router'
import {Collapse, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone'
import HelpTwoToneIcon from '@mui/icons-material/HelpTwoTone'

const AdminSection = ({
  adminDropdownOpen,
  toggleAdminDropdown,
  handleOpenHousefoliosAdmin,
}) => (
  <li>
    <a
      id="leftNavAdmin"
      href="#/"
      onClick={toggleAdminDropdown}
      data-nav-active={adminDropdownOpen || undefined}
      //   style={{
      //     color: adminDropdownOpen ? '#fff' : '#b0b8d1',
      //     fontWeight: 500,
      //     display: 'flex',
      //     alignItems: 'center',
      //     padding: '8px 16px',
      //     textDecoration: 'none',
      //     cursor: 'pointer',
      //   }}
    >
      <span data-hf="sidebar-icon">
        <FontAwesomeIcon icon={['fal', 'toolbox']} />
      </span>
      <span data-hf="sidebar-item-label">Housefolios Admin</span>
      <span data-hf="sidebar-icon-indicator">
        <ChevronRightTwoToneIcon />
      </span>
    </a>
    <Collapse in={adminDropdownOpen}>
      <ul
      //   style={{ paddingLeft: 24 }}
      >
        <Box component="li" data-hf="hover-show-hide-container" sx={{
          "& [data-hf-hover=\"show\"]": { display: "none" },
          "& [data-hf-hover=\"hide\"]": { display: "block" },
          "&:hover [data-hf-hover=\"show\"]": { display: "block" },
          "&:hover [data-hf-hover=\"hide\"]": { display: "none" },
        }}>
          <a
            id="leftNavAdminDashboard"
            href="#/"
            onClick={handleOpenHousefoliosAdmin}
            // style={{
            //   color: '#b0b8d1',
            //   display: 'flex',
            //   alignItems: 'center',
            //   padding: '6px 0',
            //   fontWeight: 400,
            //   textDecoration: 'none',
            //   fontSize: 15,
            //   cursor: 'pointer',
            // }}
          >
            <span data-hf="sidebar-icon">
              <FontAwesomeIcon size="sm" icon={['fas', 'gear']} />
            </span>
            <span data-hf="sidebar-item-label">Dashboard</span>
          </a>
        </Box>
        <Box component="li" data-hf="hover-show-hide-container" sx={{
          "& [data-hf-hover=\"show\"]": { display: "none" },
          "& [data-hf-hover=\"hide\"]": { display: "block" },
          "&:hover [data-hf-hover=\"show\"]": { display: "block" },
          "&:hover [data-hf-hover=\"hide\"]": { display: "none" },
        }}>
          <NavLink
            to="/reports"
            // style={{
            //   color: '#b0b8d1',
            //   display: 'flex',
            //   alignItems: 'center',
            //   padding: '6px 0',
            //   fontWeight: 400,
            //   textDecoration: 'none',
            //   fontSize: 15,
            // }}
          >
            <span data-hf="sidebar-icon">
              <FontAwesomeIcon
                size="sm"
                icon={['fas', 'chart-pie']}
              />
            </span>
            <span data-hf="sidebar-item-label">Reports</span>
          </NavLink>
        </Box>
        <li>
          <NavLink
            to="/housefolios-admin/clients"
          >
            <span data-hf="sidebar-icon">
              <HelpTwoToneIcon />
            </span>
            <span data-hf="sidebar-item-label">Client Support</span>
          </NavLink>
        </li>
      </ul>
    </Collapse>
  </li>
)

export default AdminSection
